<div class="grid grid--bleed guts-m-b-1" *ngIf="!isLoading">
  <div class="grid__col-6">
    <div>
      <h3 class="h3 guts-m-r-1">
        {{ 'FlexEdCtrl_FlexEdTransactionsTitle' | translate }}
      </h3>
      <span class="par par--light par--small">
        <span
          [innerHTML]="cardDetails?.availableBalance | dgxCurrency: 2"
          class="guts-m-r-quart"
        ></span
        >{{ 'FlexEdCtrl_Balance' | translate }}
      </span>
    </div>
  </div>
  <div class="grid__col-6 right-text">
    <div>
      <button
        df-button
        dfButtonType="primary"
        df-button-small
        data-dgat="User-Index-472"
        (click)="showUpdateFlexCardModal()"
      >
        {{ 'FlexEdCtrl_UpdateCardInfo' | translate }}
      </button>
    </div>
  </div>
  <dgx-flex-ed-transactions
    class="grid__col-12"
    [transactionHistory]="transactionHistory"
  ></dgx-flex-ed-transactions>
</div>
<div *ngIf="isLoading">
  <dgx-skeleton type="flexEdView"></dgx-skeleton>
</div>
<dgx-footer-glasses></dgx-footer-glasses>
